export default {
    apiUrl: "https://utils.troistudio.com",
    mailToAddress: "info@troistudio.com"
};



// WEBPACK FOOTER //
// ./src/config.js